import { NOTE_MAX_LENGTH } from "Components/Analyses/constants";
import type { GoalOverviewSubType } from "Infrastructure/ApiZfp/Schema";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, bool, date, mixed, object, string } from "yup";
import { number } from "../Utils/schemaUtils";

export type HousingMortgageGoalFormType = {
  readonly name: string;
  readonly goalSubType: GoalOverviewSubType;
  readonly remainingPrincipal: number;
  readonly remainingYears: number;
  readonly loanInterestRate: number;
  readonly loanPaymentAmount: number;
  readonly desiredRemainingYears: number;
  readonly monthlyContribution: number;
  readonly monthlyContributionWithFee: number;
  readonly interestRate: number;
  readonly inflationRate: number;
  readonly feeRate: number;
  readonly targetAmount: number;
  readonly referenceStartDate: Date;
  readonly includeInflation?: boolean;
  readonly includeEntryFee?: boolean;
  readonly note?: string;
  readonly priority?: boolean;
};

export const getHousingMortgageFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<HousingMortgageGoalFormType> = (t) => {
  return object({
    name: string().required(t(Resources.Validation.Required)),
    goalSubType: mixed<GoalOverviewSubType>().required(t(Resources.Validation.Required)),
    referenceStartDate: date().required(t(Resources.Validation.Required)),
    remainingPrincipal: number().required(t(Resources.Validation.Required)),
    remainingYears: number().required(t(Resources.Validation.Required)),
    loanInterestRate: number().required(t(Resources.Validation.Required)),
    loanPaymentAmount: number().required(t(Resources.Validation.Required)),
    desiredRemainingYears: number().required(t(Resources.Validation.Required)),
    monthlyContribution: number().required(t(Resources.Validation.Required)),
    monthlyContributionWithFee: number().required(t(Resources.Validation.Required)),
    interestRate: number().required(t(Resources.Validation.Required)),
    inflationRate: number().required(t(Resources.Validation.Required)),
    targetAmount: number().required(t(Resources.Validation.Required)),
    feeRate: number().required(t(Resources.Validation.Required)),
    includeInflation: bool().required(t(Resources.Validation.Required)),
    includeEntryFee: bool().required(t(Resources.Validation.Required)),
    note: string().max(NOTE_MAX_LENGTH, t(Resources.Validation.String.Max, { count: NOTE_MAX_LENGTH })),
    priority: bool(),
  }).defined();
};
